module.exports = __webpack_public_path__ + "img/TRANSLATE.14488258.svg";